/* eslint-disable react/prop-types */
import React from 'react';

// Campo del formulario de registro: etiqueta, icono dentro del control, error y ayuda.
// El input (con su register / onInput / onPaste) se pasa como children.
const RegField = ({ id, label, icon, error, hint, full, children }) => (
    <div className={`reg-field${full ? ' reg-field--full' : ''}${error ? ' reg-field--error' : ''}`}>
        <label className="reg-field__label" htmlFor={id}>{label}</label>
        <div className="reg-field__control">
            <i className={`fa-solid ${icon} reg-field__icon`} aria-hidden="true" />
            {children}
        </div>
        {error && <p className="reg-field__error" role="alert">{error}</p>}
        {hint && <p className="reg-field__hint">{hint}</p>}
    </div>
);

export default RegField;
